import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsPlansGrowthTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_PLAN_PERFORMER;

	get id(): string {
		return TourId.REPORTS__PLAN_PERFORMER;
	}

	override get keyForPersistantDone(): string {
		return ReportsPlansGrowthTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: false,
				attachTo: () => {
					return $('.plan.plan-growth');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
